let ctx = null;
let muted = localStorage.getItem("bsc_muted") === "1";

function ac() {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

function tone({ f = 440, f2 = null, t = 0.15, type = "sine", v = 0.18, at = 0 }) {
  if (muted) return;
  try {
    const c = ac();
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = type;
    const now = c.currentTime + at;
    o.frequency.setValueAtTime(f, now);
    if (f2) o.frequency.exponentialRampToValueAtTime(Math.max(30, f2), now + t);
    g.gain.setValueAtTime(0.0001, now);
    g.gain.exponentialRampToValueAtTime(v, now + 0.015);
    g.gain.exponentialRampToValueAtTime(0.0001, now + t);
    o.connect(g).connect(c.destination);
    o.start(now);
    o.stop(now + t + 0.05);
  } catch (e) {}
}

function noiseBurst({ t = 0.2, v = 0.06, at = 0 }) {
  if (muted) return;
  try {
    const c = ac();
    const len = Math.floor(c.sampleRate * t);
    const buf = c.createBuffer(1, len, c.sampleRate);
    const data = buf.getChannelData(0);
    for (let i = 0; i < len; i++) data[i] = (Math.random() * 2 - 1) * (1 - i / len);
    const src = c.createBufferSource();
    src.buffer = buf;
    const g = c.createGain();
    g.gain.value = v;
    src.connect(g).connect(c.destination);
    src.start(c.currentTime + at);
  } catch (e) {}
}

export const sfx = {
  pop() {
    tone({ f: 520, f2: 140, t: 0.1, type: "triangle", v: 0.22 });
    tone({ f: 900, f2: 300, t: 0.08, type: "sine", v: 0.08, at: 0.02 });
  },
  click() {
    tone({ f: 700, t: 0.05, type: "square", v: 0.07 });
  },
  boop() {
    tone({ f: 260, f2: 420, t: 0.12, type: "sine", v: 0.16 });
  },
  scribble() {
    noiseBurst({ t: 0.09, v: 0.045 });
  },
  sparkle() {
    tone({ f: 880, t: 0.1, type: "sine", v: 0.12 });
    tone({ f: 1174, t: 0.1, type: "sine", v: 0.1, at: 0.06 });
    tone({ f: 1568, t: 0.14, type: "sine", v: 0.1, at: 0.12 });
  },
  boo() {
    tone({ f: 190, f2: 85, t: 0.6, type: "sine", v: 0.14 });
  },
  fanfare() {
    const notes = [523, 659, 784, 1046];
    notes.forEach((n, i) => tone({ f: n, t: 0.2, type: "triangle", v: 0.16, at: i * 0.09 }));
    noiseBurst({ t: 0.3, v: 0.03, at: 0.35 });
  },
  unlock() {
    const notes = [392, 523, 659, 880, 1174];
    notes.forEach((n, i) => tone({ f: n, t: 0.22, type: "sine", v: 0.15, at: i * 0.07 }));
    noiseBurst({ t: 0.5, v: 0.035, at: 0.2 });
  },
};

export function isMuted() {
  return muted;
}

export function setMuted(v) {
  muted = v;
  localStorage.setItem("bsc_muted", v ? "1" : "0");
}
